module.exports = __webpack_public_path__ + "static/img/user.933c4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.png
// module id = Gvv4
// module chunks = 12